import { NavLink } from 'react-router-dom';
import { Shield, Wallet, Sparkles } from 'lucide-react';

const TOOLS = [
  {
    to: '/analyze',
    label: 'Token Health Analyzer',
    blurb: 'Bot detection · Volume manipulation · Rug risk',
    icon: Shield,
    accent: 'amber',
  },
  {
    to: '/wallet',
    label: 'Wallet Profiler',
    blurb: 'Win rate · Portfolio · Trading history',
    icon: Wallet,
    accent: 'emerald',
  },
];

/**
 * Sub-nav for the free-tool pages. Sits directly below PublicNav so a visitor
 * on one tool can see the other one exists and switch in a single click.
 */
export default function FreeToolsTabs() {
  return (
    <div className="border-b border-dark-700/50 bg-dark-900/70">
      <div className="max-w-5xl mx-auto px-4 py-4">
        <div className="flex items-center gap-2 mb-3 text-xs text-gray-500 uppercase tracking-widest">
          <Sparkles className="w-3.5 h-3.5 text-emerald-400" />
          <span className="text-emerald-400 font-semibold">Free Tools</span>
          <span className="text-gray-600">— No signup. No credit card.</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {TOOLS.map(({ to, label, blurb, icon: Icon, accent }) => (
            <NavLink
              key={to}
              to={to}
              end
              className={({ isActive }) => {
                const base =
                  'group flex items-start gap-3 p-4 rounded-xl border transition-all';
                if (isActive) {
                  return accent === 'amber'
                    ? `${base} bg-amber-500/10 border-amber-500/40 ring-1 ring-amber-500/20`
                    : `${base} bg-emerald-500/10 border-emerald-500/40 ring-1 ring-emerald-500/20`;
                }
                return `${base} bg-dark-800/50 border-dark-700 hover:border-dark-500`;
              }}
            >
              {({ isActive }) => (
                <>
                  <div
                    className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${
                      accent === 'amber'
                        ? isActive ? 'bg-amber-500/20' : 'bg-amber-500/10 group-hover:bg-amber-500/15'
                        : isActive ? 'bg-emerald-500/20' : 'bg-emerald-500/10 group-hover:bg-emerald-500/15'
                    }`}
                  >
                    <Icon
                      className={`w-5 h-5 ${
                        accent === 'amber' ? 'text-amber-400' : 'text-emerald-400'
                      }`}
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <span
                        className={`font-semibold text-sm ${
                          isActive ? 'text-white' : 'text-gray-200 group-hover:text-white'
                        }`}
                      >
                        {label}
                      </span>
                      {isActive && (
                        <span
                          className={`text-[10px] font-bold tracking-widest uppercase ${
                            accent === 'amber' ? 'text-amber-400' : 'text-emerald-400'
                          }`}
                        >
                          You are here
                        </span>
                      )}
                    </div>
                    <p className="text-xs text-gray-500 mt-0.5 leading-snug">{blurb}</p>
                  </div>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
